module.exports = __webpack_public_path__ + "static/img/0105_01.0953237.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/01/0105_01.png
// module id = ji07
// module chunks = 1